// Import general mixin for shared functionality.
import defaultApp from './defaultApp.js';

// Import components for this specific app.
import StoryItem from './components/StoryItem.vue';

const relatedContentApp = {
    ...defaultApp,
    // Overwrite default app functionalities as you please by using the spread operator.
    components: {
        ...defaultApp.components,
        StoryItem
    },
    data() {
        return {
            ...defaultApp.data(),
            dataStoryApi: '',
            dataActivityApi: '',
            dataStoryOverruleIds: [],
            dataActivityOverruleIds: [],
            dataOverruleOrder: [],

            emptyFetchCount: 0,
            storyQueryCount: 0,
            activityQueryCount: 0,
        }
    },
    computed: {
        ...defaultApp.computed,
        filterItems() {
            let filters = [];

            if (this.dataOverruleIds.length) {
                return [
                    {
                        Key: this.constants.keys.id,
                        Values: this.dataOverruleIds,
                        Operator: this.constants.operators.in,
                    }
                ];
            }

            if (this.itemsSet) {
                filters = [
                    {
                        Key: this.constants.keys.id,
                        Values: this.data.items.map(item => item.id),
                        Operator: this.constants.operators.notIn,
                    },
                ];
            }

            const extraFilters = [
                { id: this.dataThemeId, key: this.constants.keys.theme },
            ].filter(item => item.id).map(item => ({
                Key: item.key,
                Values: [item.id],
                Operator: this.constants.operators.in,
            }));

            return filters.concat(extraFilters);
        },
        queryModel() {
            let offset = 0;
            if (this.dataApi) {
                offset = this.dataApi == this.dataStoryApi ?
                    Math.floor(Math.random() * this.storyQueryCount) :
                    Math.floor(Math.random() * this.activityQueryCount);
            }

            return {
                Limit: this.dataLimit,
                Offset: offset,
                OrderItems: this.orderItems,
                FilterItems: this.filterItems,
                Text: this.searchText
            }
        },
    },
    methods: {
        ...defaultApp.methods,
        async init() {
            // Set data props according to data attributes in HTML template.
            if (this.$el.dataset.widget) this.dataWidget = true;
            if (this.$el.dataset.themeId) this.dataThemeId = this.$el.dataset.themeId;
            if (this.$el.dataset.storyOverruleIds) this.dataStoryOverruleIds = this.$el.dataset.storyOverruleIds.split(',');
            if (this.$el.dataset.activityOverruleIds) this.dataActivityOverruleIds = this.$el.dataset.activityOverruleIds.split(',');
            if (this.$el.dataset.overruleOrder) this.dataOverruleOrder = this.$el.dataset.overruleOrder.split(',');
            if (this.$el.dataset.culture) this.dataCulture = this.$el.dataset.culture;
            if (this.$el.dataset.storyApi) this.dataStoryApi = this.$el.dataset.storyApi + '?culture=' + this.dataCulture;
            if (this.$el.dataset.activityApi) this.dataActivityApi = this.$el.dataset.activityApi + '?culture=' + this.dataCulture;
            if (this.$el.dataset.limit) this.dataLimit = parseInt(this.$el.dataset.limit);

            let tempLimit = this.dataLimit;

            // Prefetch data for story overrule ids and set query count.
            this.dataApi = this.dataStoryApi;
            if (this.dataStoryOverruleIds.length) {
                this.dataOverruleIds = this.dataStoryOverruleIds;
                const storyOverruleResponse = await this.fetchData();
                this.setData(storyOverruleResponse);
                this.dataOverruleIds = [];
            }
            this.dataLimit = 0;
            const storyCountResponse = await this.fetchData();
            if (storyCountResponse && storyCountResponse.data && storyCountResponse.data.queryCount) {
                this.storyQueryCount = storyCountResponse.data.queryCount;
            }
            this.dataApi = '';
            this.dataLimit = tempLimit;

            // Prefetch data for activity overrule ids and set query count.
            this.dataApi = this.dataActivityApi;
            if (this.dataActivityOverruleIds.length) {
                this.dataOverruleIds = this.dataActivityOverruleIds;
                const activityOverruleResponse = await this.fetchData();
                this.setData(activityOverruleResponse);
                this.dataOverruleIds = [];
            }
            this.dataLimit = 0;
            const activityCountResponse = await this.fetchData();
            if (activityCountResponse && activityCountResponse.data && activityCountResponse.data.queryCount) {
                this.activityQueryCount = activityCountResponse.data.queryCount;
            }
            this.dataApi = '';
            this.dataLimit = tempLimit;

            // Make sure ordering corresponds to picking order in CMS.
            if (this.data.items.length) {
                this.data.items = this.data.items.sort((a, b) => this.dataOverruleOrder.indexOf(a.id) - this.dataOverruleOrder.indexOf(b.id));
            }

            this.dataApi = this.$el.dataset.isActivityPage === 'True' ? this.dataActivityApi : this.dataStoryApi;

            // Data fetch with alternating random story and activity items.
            while (this.data.items.length < tempLimit && this.emptyFetchCount < 2) {
                this.dataLimit = 1;
                const response = await this.fetchData();
                if (!response || response.status != 200 || !response.data || !response.data.items) break;

                const newItems = response.data.items.filter(item =>
                    !this.data.items.some(existing => existing.id === item.id)
                );

                if (newItems.length) {
                    this.dataApi == this.dataStoryApi ?
                        this.storyQueryCount = response.data.queryCount - newItems.length :
                        this.activityQueryCount = response.data.queryCount - newItems.length;
                    this.setData(response);
                    this.emptyFetchCount = 0;
                } else {
                    this.emptyFetchCount++;

                    if (this.emptyFetchCount > 1 && this.dataThemeId) {
                        this.dataThemeId = '';
                        this.emptyFetchCount = 0;
                    }
                }

                this.dataApi = this.dataApi === this.dataStoryApi ? this.dataActivityApi : this.dataStoryApi;
            }

            this.dataLimit = tempLimit;

            // Remove duplicates from items.
            if (this.itemsSet) {
                this.data.items = this.removeDuplicatesById(this.data.items);
                if (this.dataWidget) this.data.items = this.data.items.slice(0, this.dataLimit);
            }

            this.$nextTick(() => {
                this.initSwiperIfNeeded();
            });
        },
        getMode(index) {
            switch (true) {
                case index % 2 === 1:
                    return this.constants.images.modes.image;
                default:
                    return this.constants.images.modes.normal;
            }
        },
    },
    
};

export default relatedContentApp;
